var _rect, _circle, _path, _rect2, _rect3, _circle2, _path2, _rect4, _rect5, _circle3, _path3, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 144,
    viewBox: "0 0 238 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 238,
    height: 143,
    rx: 8,
    fill: "#F3F5F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28.7324,
    r: 12,
    fill: "#DCDEE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 23.4824L22.5 28.3574H18.75V29.1074H22.5L18.75 33.9824H29.25L25.5 29.1074H29.25V28.3574H25.5L29.25 23.4824H18.75ZM25.5 28.3574V29.1074H22.5V28.3574H25.5ZM20.2731 24.2324L22.8693 27.6074H25.1307L27.7269 24.2324H20.2731ZM22.8693 29.8574L20.2731 33.2324H27.7269L25.1307 29.8574H22.8693Z",
    fill: "#202123",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16.7324,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32.7324,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 68.7324,
    r: 12,
    fill: "#DCDEE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 63.4824L22.5 68.3574H18.75V69.1074H22.5L18.75 73.9824H29.25L25.5 69.1074H29.25V68.3574H25.5L29.25 63.4824H18.75ZM25.5 68.3574V69.1074H22.5V68.3574H25.5ZM20.2731 64.2324L22.8693 67.6074H25.1307L27.7269 64.2324H20.2731ZM22.8693 69.8574L20.2731 73.2324H27.7269L25.1307 69.8574H22.8693Z",
    fill: "#202123",
    fillOpacity: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 56.7324,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 72.7324,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 108.732,
    r: 12,
    fill: "#DCDEE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 103.482L22.5 108.357H18.75V109.107H22.5L18.75 113.982H29.25L25.5 109.107H29.25V108.357H25.5L29.25 103.482H18.75ZM25.5 108.357V109.107H22.5V108.357H25.5ZM20.2731 104.232L22.8693 107.607H25.1307L27.7269 104.232H20.2731ZM22.8693 109.857L20.2731 113.232H27.7269L25.1307 109.857H22.8693Z",
    fill: "#202123",
    fillOpacity: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 96.7324,
    width: 186,
    height: 12,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 112.732,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#202123",
    fillOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.199738d9ab3ef84453d9a0004bac7c5a.svg";
export { ForwardRef as ReactComponent };